import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

// This function creates a set of functions that help us create multipart component styles.
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(['control', 'label']);

const sizes = {
    sm: definePartsStyle({
        label: { fontSize: 'sm' },
        icon: { fontSize: '3xs' },
    }),
    md: definePartsStyle({
        label: { fontSize: 'md' },
        icon: { fontSize: '2xs' },
    }),
    lg: definePartsStyle({
        label: { fontSize: 'md' },
        icon: { fontSize: '2xs' },
    }),
};

export const checkboxTheme = defineMultiStyleConfig({
    baseStyle: {
        label: {
            marginInlineStart: '8px',
        },
        control: {
            borderColor: '#FFFFFF',
            border: '1px solid',

            _checked: {
                color: 'grayDark2',
                borderColor: '#FFFFFF',
                backgroundColor: '#FFFFFF',
                _hover: {
                    borderColor: '#FFFFFF',
                    backgroundColor: '#FFFFFF',
                },
            },
        },
    },
    sizes,
    variants: {},
    defaultProps: {
        size: 'lg',
        fontSize: 'sm',
    },
});
